import type { MantineColorsTuple } from '@mantine/core';

export const colors = {
  primary: [
    '#EAF1FF',
    '#D6E3FF',
    '#ADC7FF',
    '#83AAFF',
    '#5A8EFF',
    '#3172FF',
    '#275CCE',
    '#1D469C',
    '#142F6B',
    '#0A1939',
  ],
  error: [
    '#FCE9E9',
    '#F9D4D2',
    '#F3A9A6',
    '#EC7D79',
    '#E6524D',
    '#E02720',
    '#B31F1A',
    '#861713',
    '#5A100D',
    '#2D0806',
  ],
  warning: [
    '#FEF7E5',
    '#FDEFCC',
    '#FBDF99',
    '#F8CF66',
    '#F6BF33',
    '#F4AF00',
    '#C38C00',
    '#926900',
    '#624600',
    '#312300',
  ],
  success: [
    '#EEF6EE',
    '#DDEDDD',
    '#BADBBA',
    '#98CA98',
    '#75B875',
    '#53A653',
    '#428542',
    '#326432',
    '#214221',
    '#112111',
  ],
  neural: [
    '#FAFAFA',
    '#F5F5F5',
    '#E5E5E5',
    '#D4D4D4',
    '#A3A3A3',
    '#737373',
    '#525252',
    '#404040',
    '#262626',
    '#171717',
  ],
} satisfies Record<string, MantineColorsTuple>;

export const success = '#099250';
export const danger = '#E02720';
export const warning = '#F4AF00';
